import { useApi } from '@/utils/request'

export const useSubscriptionApi = () => {
  const [api] = useApi()

  const subscribePlan = (data) => {
    return api({
      url: '/subscription/subscribe',
      method: "post",
      data: data
    })
  }


  const accessBillingPortal = () => {
    return api({
      url: '/subscription/billingportal',
      method: "get",
    })
  }
     
  return {
    subscribePlan,
    accessBillingPortal
  }
  
}
